/*
 Create by smg  2015-12-23
 */
"use strict";
angular.module("productManageMentWebsiteColumnModule", [
        'mangeProColumnCtrlModule',
        "websiteServiceModule",
        'productManageMentWebsiteColumnRecycleBinModule',
        'productManageMentWebsiteColumnRouterModule'
    ])
    .controller("productManageMentWebsiteColumnCtrl", ['$scope', '$timeout', '$rootScope', '$q', '$state', '$modal', '$stateParams', 'trsHttpService', "websiteService", "modalDialog", "productMangageMentWebsiteService", "localStorageService", "previewToolService", "trsspliceString", function($scope, $timeout, $rootScope, $q, $state, $modal, $stateParams, trsHttpService, websiteService, modalDialog, productMangageMentWebsiteService, localStorageService, previewToolService, trsspliceString) {
        initStatus();
        initData();
        /**
         * [getChnlRights description] 获取操作权限
         * @return {[type]} [description]
         */
        function getChnlRights() {
            productMangageMentWebsiteService.getRight("", $stateParams.parentchnl, "websetchannel.channel").then(function(data) {
                $scope.status.right = data;
            });
        }
        /**
         * [clickSiteDirected description]点击站点重定向开始
         * @return null [description]
         */
        $scope.clickChnlDirected = function(item) {
            productMangageMentWebsiteService.getCloumnAccessAuthority($stateParams.parentchnl).then(function(data) {
                //將权限信息存入缓存，用于底部路由区加载使用开始
                localStorageService.set("rightOperType", {
                    type: data.router,
                    data: data.data
                });
                //將权限信息存入缓存，用于底部路由区加载使用结束
                $state.go("manageconfig.productmanage.website.column", {
                    channel: item.CHANNELID,
                    parentchnl: $stateParams.parentchnl
                }, { reload: true });
            });
        };
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData().then(function(data) {
                $scope.websiteItems = data.DATA;
                $scope.websiteItems !== "" ? $scope.selectedColumn = $scope.websiteItems[0] : "";
            });
        }
        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            var defferd = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                defferd.resolve(data);
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
            });
            return defferd.promise;
        }
        /**
         * [searchColumn description] 通过关键词搜索
         * @return {[type]} [description]
         */
        $scope.searchColumn = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.serviceid = "mlf_websiteconfig";
                $scope.params.methodname = "queryChannelsByChannelForCloud";
                $scope.params.ChannelId = $stateParams.channel;
                $scope.params.ChnlDesc = $scope.searchColumnByName;
                requestData().then(function(data) {
                    $scope.websiteItems = data.DATA;
                });
            }
        };
        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                PmmWebsiteChnlSelected: $stateParams.websiteselect,
                right: {},
                selectedArray: [],
                publishOptions: [
                    { name: '仅发布首页', value: 1 },
                    { name: '完全发布', value: 0 }
                ],
                status: $stateParams.status,
                statusOptions: [{
                    name: "全部状态",
                    value: null
                }, {
                    name: "启用",
                    value: 0,
                }, {
                    name: "停用",
                    value: -1
                }]
            };
            $scope.status.selectStatus = $scope.status.statusOptions[0];
            $scope.page = {
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                CURRPAGE: 1,
                PAGECOUNT: 1,
                copyCurrPage: 1
            };
            $scope.params = {
                serviceid: "mlf_websiteconfig",
                methodname: "queryChannelsByChannelForCloud",
                ChannelId: $stateParams.channel,
                pageSize: $scope.page.PAGESIZE,
                currpage: $scope.page.CURRPAGE,
                status: null
            };
            $scope.data = {
                channelPath: "",
            };
            $scope.superiorChn = $stateParams.channel;
            getChnlRights();
        }

        /**
         * [selectStatus description]根据状态筛选栏目
         * @params [{}] [description]
         * @return null [description]
         */
        $scope.selectStatus = function() {
            $scope.params.status = $scope.status.selectStatus.value;
            requestData().then(function(data) {
                $scope.websiteItems = data.DATA;
                $scope.websiteItems !== "" ? $scope.selectedColumn = $scope.websiteItems[0] : "";
            });
        };
        /** [pageChanged description]: 翻页功能 */
        $scope.pageChanged = function() {
            $scope.page.copyCurrPage = $scope.page.CURRPAGE;
            $scope.params.currpage = $scope.page.CURRPAGE;
            requestData().then(function(data) {
                $scope.websiteItems = data.DATA;
                $scope.websiteItems !== "" ? $scope.selectedColumn = $scope.websiteItems[0] : "";
            });
        };
        /** [selectPageNum description] 选择单页数据条数 */
        $scope.selectPageNum = function() {
            $scope.params.pageSize = $scope.page.PAGESIZE;
            requestData().then(function(data) {
                $scope.websiteItems = data.DATA;
                $scope.websiteItems !== "" ? $scope.selectedColumn = $scope.websiteItems[0] : "";
            });
        };
        /** [jumpToPage description: 跳转到第几页] */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = $scope.page.copyCurrPage;
            $scope.params.currpage = $scope.page.CURRPAGE;
            requestData().then(function(data) {
                $scope.websiteItems = data.DATA;
                $scope.websiteItems !== "" ? $scope.selectedColumn = $scope.websiteItems[0] : "";
            });
        };
        /**
         * [selectAll description] 选中全部栏目
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.status.selectedArray = $scope.status.selectedArray.length == $scope.websiteItems.length ? [] : [].concat($scope.websiteItems);
        };
        /**
         * [selectChannel description] 选中某个栏目
         * @param {[object]} [channel] [description] 栏目数据
         * @return {[type]} [description]
         */
        $scope.selectChannel = function(channel) {
            if ($scope.status.selectedArray.indexOf(channel) < 0) {
                $scope.status.selectedArray.push(channel);
            } else {
                $scope.status.selectedArray.splice($scope.status.selectedArray.indexOf(channel), 1);
            }
        };
        //发布栏目
        $scope.publish = function(item) {
            $scope.status.selectedPublishWay = item.value;
            $timeout(function() {
                if ($scope.status.selectedPublishWay === 1) $scope.publishHome($scope.status.selectedArray[0]);
                else $scope.publishFull($scope.status.selectedArray[0]);
            });
            //websiteService.websitePublish(websiteItem.CHANNELID, "101");
        };
        /**
         * [singlePublish description] 单个栏目发布
         * @param  {[type]} channel [description] 栏目数据
         * @return {[type]}      [description]
         */
        $scope.singlePublish = function(channel) {
            $timeout(function() {
                if ($scope.status.selectedPublishWay.value === 1) $scope.publishHome(channel);
                else $scope.publishFull(channel);
            });
        };
        /**
         * [batDelete description] 批量删除方法
         * @return {[type]} [description]
         */
        $scope.batDelete = function() {
            if ($scope.status.selectedArray.length == 0) {
                modalDialog.alertType("请先选择一个栏目", "", "warning", false);
                return;
            } else {
                modalDialog.alertType("确定要删除选中的栏目吗", "", "warning", true, function() {
                    $scope.deleteViews($scope.status.selectedArray);
                });
            }
        };
        /**
         * [moveViews description] 移动栏目
         * @return {[type]} [description]
         */
        $scope.moveViews = function() {
            productMangageMentWebsiteService.singleChooseChnl("移动栏目", $stateParams.site, $scope.status.selectedArray[0].CHANNELID, function(data) {
                delete $scope.params.ChannelId;
                if (angular.isDefined(data.CHANNELID)) {
                    $scope.params.ChannelId = data.CHANNELID;
                    $scope.targetDesc = data.CHNLDESC;
                } else {
                    $scope.targetDesc = data.SITEDESC;
                }
                $scope.params.SiteId = $stateParams.site;
                $scope.params.serviceid = "mlf_websiteconfig";
                $scope.params.methodname = "moveToBaseChannel";
                $scope.params.FromChnlId = $scope.status.selectedArray[0].CHANNELID;
                $scope.params.TopChannelId = $stateParams.parentchnl;
                requestData().then(function(data) {
                    $state.go($state.current.name, $stateParams, { reload: true }); //左右两侧同时刷新
                });
            });
        };
        /**
         * [batMove description] 批量移动栏目
         * @return {[type]} [description]
         */
        $scope.batMove = function() {
            if ($scope.status.selectedArray.length !== 1) {
                modalDialog.alertType("请选择一个栏目", "", "warning", false);
                return;
            }
            $scope.moveViews();
        };
        //修改弹窗
        $scope.modify = function(websiteChannel) {
            var column = {
                title: "修改栏目",
                isColumn: true
            };
            $scope.modifyViews(column, function(data) {}, websiteChannel);
        };
        //新增弹窗
        $scope.add = function() {
            var column = {
                title: "新增栏目",
                isColumn: true
            };
            $scope.modifyViews(column, function(data) {}, "");
        };


        /**
         * [deleteSite description]删除栏目
         * @params [{chnlId}] [description] 栏目信息
         * @return null [description]
         */
        $scope.deleteViews = function(item) {
            $scope.selectChannelIds = trsspliceString.spliceString(item, "CHANNELID", ",");
            var ckConditionParamas = {
                serviceid: "mlf_websiteconfig",
                methodname: "checkChannelCondition",
                ChannelIds: $scope.selectChannelIds
            };
            var deleteParams = {
                serviceid: "mlf_websiteconfig",
                methodname: "RemoveChannels",
                ChannelIds: $scope.selectChannelIds,
                TopChannelId: '0',
                PassWord: ""
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), ckConditionParamas, "get")
                .then(function(data) {
                    productMangageMentWebsiteService.inputPassword(function(password) {
                        LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                            deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "get")
                                .then(function(data) {
                                    modalDialog.alertType("删除成功", "", "success", false);
                                    $state.go($state.current.name, $stateParams, { reload: true });
                                });
                        });
                    });
                });
        };
        /**
         * [addChildren description] 新增子站点
         */
        $scope.addChildren = function(channel) {
            var column = {
                title: "新增子栏目",
                isColumn: true
            };
            addColumn(column, channel, function() {});
        };

        function addColumn(column, channel, successFn) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/website/channel/template/channel_modify_tpl.html",
                windowClass: 'productManageMent-website-channel-modify',
                backdrop: false,
                controller: "columnModifyCtrl",
                resolve: {
                    column: function() {
                        return column;
                    },
                    successFn: function() {
                        return successFn;
                    },
                    websiteChannel: function() {
                        return "";
                    },
                    selfChannel: function() {
                        return channel;
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                $scope.params = result;
                $scope.params.serviceid = "mlf_websiteconfig";
                $scope.params.methodname = "saveNewChnl";
                $scope.params.TopChannelId = $stateParams.parentchnl;
                $scope.params.CHNLDATAPATH = result.DATAPATH;
                requestData().then(function(data) {
                    modalDialog.alertType('新增子栏目成功', "", "success", false);
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
            });
        }
        //修改弹窗方法
        $scope.modifyViews = function(column, successFn, websiteChannel) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/website/channel/template/channel_modify_tpl.html",
                windowClass: 'productManageMent-website-channel-modify',
                backdrop: false,
                controller: "columnModifyCtrl",
                resolve: {
                    column: function() {
                        return column;
                    },
                    successFn: function() {
                        return successFn;
                    },
                    websiteChannel: function() {
                        return websiteChannel;
                    },
                    selfChannel: function() {
                        return "";
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                $scope.params = result;
                $scope.params.serviceid = "mlf_websiteconfig";
                $scope.params.methodname = "saveNewChnl";
                $scope.params.TopChannelId = $stateParams.parentchnl;
                $scope.params.CHNLDATAPATH = result.DATAPATH;
                requestData().then(function(data) {
                    modalDialog.alertType("", column.title + '成功', "success", false, function() {});
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
            });
        };
        //栏目预览
        $scope.preview = function(websiteItem) {
            previewToolService.channelPreview(websiteItem);
        };
        //发布到首页
        $scope.publishHome = function(websiteItem) {
            if (!$scope.status.right.channel.solopublish) {
                modalDialog.alertType('您没有该栏目的仅发布首页权限', '', 'warning', 'confirm');
                return;
            }
            modalDialog.alertType('确认要发布该栏目首页吗？', '', 'ask', true, () => {
                websiteService.websitePublish(websiteItem.CHANNELID, "101", $stateParams.parentchnl);
            })
        };
        //完全发布
        $scope.publishFull = function(websiteItem) {
            if (!$scope.status.right.channel.publish) {
                modalDialog.alertType('您没有完全发布该栏目的权限', '', 'warning', 'confirm');
                return;
            }
            modalDialog.alertType('确认要完全发布该栏目吗？', '', 'ask', true, () => {
                var publishParams = {
                    serviceid: "mlf_publish",
                    methodname: "fullyPublish",
                    ObjectIds: websiteItem.CHANNELID,
                    ObjectType: '101',
                    TopChannelId: $stateParams.parentchnl,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), publishParams, "post").then(
                    function(data) {
                        modalDialog.alertType("发布成功", "", "success", false);
                    });
            });

        };
        /**
         * [enableDisable description]启用停用频道
         * @return null [description]
         */
        $scope.enableDisable = function(websiteItem) {
            if (websiteItem.STATUS === '0') {
                $scope.disableSite(websiteItem);
            } else {
                $scope.reductionViews(websiteItem);
            }
        };
        /**
         * [disableSite description]停用频道
         * @return null [description]
         */
        $scope.disableSite = function(websiteItem) {
            var checkParams = {
                serviceid: "mlf_websiteconfig",
                methodname: "deleteChannelCondition",
                ChannelId: websiteItem.CHANNELID,
                TopChannelId: '0'
            };
            var deleteParams = {
                serviceid: "mlf_websiteconfig",
                methodname: "deleteChannel",
                ChannelId: websiteItem.CHANNELID,
                TopChannelId: '0'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, "post")
                .then(function(data) {
                    modalDialog.inputModel("停用", "停用原因（选填）", function(data) {
                        productMangageMentWebsiteService.inputPassword(function(password) {
                            LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                                deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "post")
                                    .then(function(data) {
                                        modalDialog.alertType("停用成功", "", "success", false);
                                        $state.go($state.current.name, $stateParams, { reload: true });
                                    });
                            });
                        });
                    });
                });

        };
        /**
         * [reductionViews description]启用频道
         * @params [{websiteItem}] [description] 频道信息
         * @return null [description]
         */
        $scope.reductionViews = function(websiteItem) {
            modalDialog.alertType("确定启用该频道？", "", "ask", true, function() {
                var reSiteParams = {
                    serviceid: "mlf_websiteconfig",
                    methodname: "restoreChannels",
                    ObjectIds: websiteItem.CHANNELID,
                    SiteId: $stateParams.site,
                    TopChannelId: '0',
                    RestoreAll: false
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), reSiteParams, "post")
                    .then(function(data) {
                        modalDialog.alertType("启用成功", "", "success", false);
                        $state.go($state.current.name, $stateParams, { reload: true });
                    });
            });
        };
    }]);